
















































































































import { VbSnackbarService } from 'bag-of-holding-library';
import { Vue, Component, Prop } from 'vue-property-decorator';
import moment from 'moment';
import VueToExcel from 'vue-json-excel';
import VueApexCharts from 'vue-apexcharts';
import CandidateReasoningResult from '@/domain/selective-process/entity/candidate/candidate-reasoning-result.entity';
import CandidateService from '@/domain/selective-process/service/candidate.service';
import Loading from '@/shared/loading/loading.component.vue';
import ReasoningHeaders from '../candidate/reasoning-table-header.json';
import ReasonginAnswersHeaders from './reasoning-answer-header.json';
import ResetSurveyModal from '../modal/reset-survey-modal.component.vue';


@Component({
  components: {
    Loading,
    VueApexCharts,
    ResetSurveyModal,
    VueToExcel,
  },
})
export default class ReasoningResultComponent extends Vue {
  @Prop({
    type: String,
    required: true,
  }) candidateAssessmentId!: string;

  @Prop({
    type: Boolean,
    required: true,
  }) hasResetPermission!: boolean;

  @Prop({
    type: String,
    required: true,
  }) candidateName!: string;

  reasoningResults: CandidateReasoningResult[] = [];

  loading: boolean = false;

  reasoningHeaders = ReasoningHeaders;

  reasoningAnswerHeaders = ReasonginAnswersHeaders;

  openResetModal: boolean = false;

  resetSurveyAnswerId: string = '';

  resetSurveyName: string = '';

  reasoningResultChartOptions = {
    chart: {
      type: 'bar',
    },
    plotOptions: {
      bar: {
        borderRadius: 4,
        borderRadiusApplication: 'end',
        horizontal: true,
      },
    },
    dataLabels: {
      enabled: false,
    },
    xaxis: {
      categories: [''],
      min: 0,
      max: 100,
      labels: {
        style: {
          fontSize: '14px',
          fontFamily: 'Roboto',
          fontWeight: 400,
        },
      },
      title: {
        text: 'Percentil',
        style: {
          fontSize: '16px',
          fontFamily: 'Roboto, sans-serif',
          fontWeight: 500,
        },
      },
    },
    yaxis: {
      labels: {
        style: {
          fontSize: '14px',
          fontFamily: 'Roboto, sans-serif',
          fontWeight: 400,
        },
      },
    },
    tooltip: {
      followCursor: true,
      y: {
        formatter: value => `${value}%`,
        title: {
          formatter: () => '',
        },
      },
    },
  }

  reasoningResultChartSeries: any[] = [{
    data: [],
  }]

  xlsFields: any = {
    Questão: 'questionPosition',
    Titulo: 'questionTitle',
    Resposta: 'answerValue',
    'Resposta Correta': 'correctAnswer',
  }

  created() {
    this.getReasoningResult();
  }

  async getReasoningResult() {
    this.loading = true;
    await CandidateService.getReasoningResult(this.candidateAssessmentId)
      .then((response: CandidateReasoningResult[]) => {
        this.reasoningResults = response;
        this.setChartData();
      })
      .catch((error) => {
        VbSnackbarService.handleHttpError(error);
      })
      .finally(() => {
        this.loading = false;
      });
  }

  setChartData() {
    this.reasoningResultChartSeries[0].data = this.reasoningResults
      .map(it => it.percent)
    this.reasoningResultChartOptions.xaxis.categories = this.reasoningResults
      .map(it => it.name)
  }

  formatDateTime(date: string): string {
    return moment(date).format('DD/MM/YYYY HH:mm');
  }

  getDurantion(result: CandidateReasoningResult): string {
    const start = moment(result.startedDate);
    const end = moment(result.concludedDate);
    moment.locale('pt-br')
    return moment.duration(end.diff(start)).humanize();
  }

  showResetModal(result: CandidateReasoningResult) {
    this.resetSurveyAnswerId = result.surveyAnswerId;
    this.resetSurveyName = result.name;
    this.openResetModal = true;
  }
}
